<template>
<div class="modal fade trade-quest-modal" :id="'tradeQuest' + tradeArcadeId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Trade Quest</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <h3>Trade Quest Challenges</h3>
                <p class="text-center mb-0">
                    Trade for or trade away pins that matches each one of these themes for a chance to win a
                    Pin Prize and free Trade Tokens.
                </p>

                <!-- <div v-if="!tradeId" class="d-block d-lg-none text-center">
                    <a href="/my/trades" class="btn btn-link">Mark complete in your Trades Won</a>
                </div> -->

                <div v-if="tradeId" class="fs-1 fw-bold text-center d-lg-none lh-sm mt-4 mb-0">Which challenge(s) does this trade complete?</div>
                <p class="small text-center text-secondary">A single trade is required for each challenge to count (a single pin can't count for multiple challenges).</p>
                
                <div class="trade-quest-challenges">
                    <div v-for="challenge in challenges" :key="challenge.id" class="quest-item-wrapper mb-5">
                        <div class="quest-item" :class="{'active': challenge.is_complete}">
                            <div class="quest-border">
                                <div class="quest-icon">
                                    <i :class="challenge.icon"></i>
                                </div>
                            </div>
                        </div>
                        <h4 class="font-arcade">{{ challenge.name }}</h4>
                        <p class="">{{ challenge.description }}</p>
                        <button v-if="tradeId" @click="toggleTraded(challenge.id)" class="btn btn-sm" :class="challenge.is_complete ? 'btn-dark text-light' : 'btn-outline-secondary'">traded</button>
                    </div>
                </div>

                <div v-if="tradeId" class="fs-2 fw-bold text-center d-none d-lg-block">Which challenge(s) does this trade complete?</div>

                <!-- <div v-if="!tradeId" class="text-center">
                    <a href="/my/trades" class="btn btn-link">Mark complete in your Trades Won</a>
                </div> -->

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
</template>
    
<script>
export default {
    name: 'TradeQuest',
    props: {
        tradeArcadeId: {
            type: Number,
            required: true
        },
        tradeQuest: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            challenges: this.tradeQuest,
            tradeId: null
        }
    },
    methods: {
        toggleTraded(id) {
            let challenge = this.challenges.find(challenge => challenge.id === id);
            if (challenge.is_complete) {
                // challenge.is_complete = false;
                axios.delete('/pin-trading/trade-quest/' + id, {
                    //
                }).then(response => {
                    challenge.is_complete = false;
                }).catch(error => {
                    //
                });
            } else {
                // challenge.is_complete = true;
                axios.post('/pin-trading/trade-quest/' + id, {
                    trade_id: this.tradeId
                }).then(response => {
                    challenge.is_complete = true;
                }).catch(error => {
                    //
                });
            }
        }
    },
    mounted() {
        document.getElementById('tradeQuest' + this.tradeArcadeId).addEventListener('show.bs.modal', (e) => {
            const tradeId = e.relatedTarget.getAttribute('data-trade-id');
            this.tradeId = tradeId;
        });
    }
}
</script>